export const isPathAllowed = (path: string, includedPaths: string[], excludedPaths: string[]) => {
  const included = includedPaths.some((url) => path.includes(url))
  const excluded = excludedPaths.some((url) => path.includes(url))
  return included && !excluded
}
